import moment from "moment-timezone";

export interface IReportFilterOp {
    DataDa: string,
    DataA: string,
    IdOperatore: {value: string, label: string} | any,
    IdSupervisore: {value: string, label: string} | any,
}

export function AdapterReportFilterCalls(filter: IReportFilterOp) {
    let filterMap: IReportFilterOp;
    return filterMap = {
        DataDa: filter?.DataDa ? moment.tz(filter?.DataDa, "DD-MM-YYYY HH:mm", "Europe/Rome").toISOString() : '',
        DataA: filter?.DataA ? moment.tz(filter?.DataA, "DD-MM-YYYY HH:mm", "Europe/Rome").toISOString() : '',
        IdOperatore: filter?.IdOperatore?.value ? Number(filter?.IdOperatore?.value) : null,
        IdSupervisore: filter?.IdSupervisore?.value ? Number(filter?.IdSupervisore?.value) : null,
    } 
} 

